import KycRequirements from './kyc-requirements';
import GovernmentId from './government-id';
import ProofOfEmployment from './proof-of-employment';
import PayrollAccountDetails from './payroll-account-details';
KycRequirements.GovernmentId = GovernmentId;
KycRequirements.ProofOfEmployment = ProofOfEmployment;
KycRequirements.PayrollAccountDetails = PayrollAccountDetails;
export default KycRequirements;
//# sourceMappingURL=index.js.map